






















import Vue, { PropType } from 'vue'

import { Widget } from '../base/'

import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  name: 'iframe-widget',
  components: {
    NoWidgetAccess,
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {

    }
  },
  computed: {
    showAsImage() {
      return this.widget?.customSettings.settings?.showAsImage.checked
    },
    targetUri() {
      return this.widget?.customSettings.settings?.targetUri.value
    },
  }
})
